import { render } from "./RegistrationCount.vue?vue&type=template&id=3a09e414"
import script from "./RegistrationCount.vue?vue&type=script&lang=js"
export * from "./RegistrationCount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ibrahimisa/Documents/Work/HibSoft/Projects/Frontier-Systems/Projects/geomaps-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__